import { createAction } from "@ngrx/store";

export const invoiceDetailsCompleted = createAction('[INVOICE] GET INVOICE COMPLETED');

export const refreshTable = createAction('[INVOICE] REFRESH TABLE');
